var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElTooltip',{attrs:{"content":_vm.locked ? 'ロック解除' : 'ロック'}},[_c('div',{staticClass:"c-icon-button u-mr8",on:{"click":function($event){return _vm.$emit('toggle')}}},[(_vm.locked)?_c('IconLocked'):_c('IconLock')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }